<!-- <div class="container-scroller">
  <ib-header></ib-header>
  <div class="container-fluid page-body-wrapper">
    <ib-sidebar></ib-sidebar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->

<div class="container-scroller">
    <ib-sidebar></ib-sidebar>
    <ib-header></ib-header>
    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>
